import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useRouter } from 'next/router';
import { IconButton } from '@mui/material';
import { ESPaginationInfo } from 'server/api/types';
import { useCurrentUser } from 'lib/contexts/ApplicationState';
import { useEffect, useState } from 'react';
import { NoPaginationBox } from './NoPaginationBox';

interface Props {
  paging: ESPaginationInfo;
  isLoading: boolean;
  hideNoPaginationBox?: boolean;
  disableLoadMore?: boolean;
}

const MAX_RESULTS = 8000;

const extractUsernameFromPath = (path: string) => path.split('?')[0];

// TODO: add goTo prop to help when query props are in path name
export const Pagination = ({
  paging,
  isLoading,
  hideNoPaginationBox,
  disableLoadMore,
}: Props) => {
  const [_isLoading, setIsLoading] = useState(isLoading);
  const router = useRouter();
  const currentUser = useCurrentUser();

  const goTo = (from: number) => {
    setIsLoading(true);
    // TODO(Jordan): There must be a less hacky way to do this.
    const newPathname = router.pathname === '/[profileuser]'
      ? extractUsernameFromPath(router.asPath)
      : router.pathname;
    const newQuery = { ...router.query, ...{ from } };

    router.push({
      query: newQuery,
      pathname: router.pathname,
    },
    {
      query: newQuery,
      pathname: newPathname,
    }, { shallow: true });
  };

  useEffect(() => {
    setIsLoading(isLoading);
  }, [isLoading]);

  if (!paging || paging?.count <= paging?.size) {
    return null;
  }

  if (paging?.nextFrom > paging?.count || paging?.from > MAX_RESULTS) {
    return (
      <div className="my-6 flex gap-2 justify-center items-center text-xl">
        <IconButton
          onClick={() => window.scrollTo(0, 0)}
        >
          <span className="btn-primary">
            <VerticalAlignTopIcon className="mr-1" />
            The end - Go back to top
          </span>
        </IconButton>
      </div>
    );
  }

  if (!currentUser && !hideNoPaginationBox) return (<div className="my-4"><NoPaginationBox /></div>);

  return (
    <div className="my-6 flex gap-2 justify-center items-center text-xl">
      <IconButton
        onClick={() => goTo(paging.from + paging.size)}
        disabled={_isLoading || disableLoadMore}
      >
        <span className={`${disableLoadMore && 'bg-gray-400'} btn-primary`}>
          <RefreshIcon className="mr-1" />
          {_isLoading ? 'Loading...' : 'Load more'}
        </span>
      </IconButton>
      <IconButton
        onClick={() => window.scrollTo(0, 0)}
      >
        <span className="btn-primary-outlined">
          <VerticalAlignTopIcon className="mr-1" />
          Back to top
        </span>
      </IconButton>

    </div>
  );
};
